export const convertApiLocale = (locale: string) => 
	locale === 'zh-Hans' ? 'zh-CHS' : locale;

export const convertClientLocale = (locale: string) => 
	locale === 'zh-CHS' ? 'zh-Hans' : locale;